<template>
	<MainColumn>
		<v-expand-transition>
			<div class="openingtime-container" v-if="infoOpeningTimeCentrale || infoOpeningTimeSuccursale">
				<div
					class="openingtime"
					@click="updateProperty({ property: 'contactsDialog', value: true })"
				>
					<span
						v-if="infoOpeningTimeCentrale"
						v-html="infoOpeningTimeCentrale.time"
					></span>
					<span
						v-if="infoOpeningTimeSuccursale"
						v-html="infoOpeningTimeSuccursale.time"
					></span>
				</div>
			</div>
		</v-expand-transition>
	</MainColumn>
</template>
<script>
export default {
	props: ["block", "blocks", "parentBlock"],
	components: {},
	async mounted() {
		// Carica orari sede centrale
		if (!this.infoOpeningTimeCentrale) {
			let response = await this.$api.get("/wp-json/qzrstudio/v1/openingtime2?category=sede-centrale");
			setTimeout(() => {
				this.updateProperty({
					property: "infoOpeningTimeCentrale",
					value: response.data,
				});
			}, 2500);
		}
		
		// Carica orari succursale
		if (!this.infoOpeningTimeSuccursale) {
			let response = await this.$api.get("/wp-json/qzrstudio/v1/openingtime2?category=succursale");
			setTimeout(() => {
				this.updateProperty({
					property: "infoOpeningTimeSuccursale",
					value: response.data,
				});
			}, 2500);
		}
	},
};
</script>
<style lang="scss" scoped>
.container {
	z-index: 100;
}

.openingtime-container {
	position: absolute;
	top: calc(94vh - 90px);
	transform: translateY(-50%);
	z-index: 500;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.openingtime span {
	float: left;
	margin-right: 6px;
	font-weight: bold !important;
}

.openingtime p {
	margin-bottom: 0;
}

.openingtime {
	font-size: $font-size-14;
	border-radius: 25px;
	border-bottom-left-radius: 0;
	padding: 1rem $spacing-0;
	background: #fff;
	cursor: pointer;
	display: flex;
    flex-direction: column;
}

.openingtime a {
	color: #000;
}

@media only screen and (max-width: 1024px) {
	.openingtime-container {
		top: calc(94vh - 30px);
	}
}

@media only screen and (max-width: 550px) {
	.openingtime-container {
		width: calc(100%);
	}
}

@media only screen and (max-width: 320px) {
	.openingtime-container {
		top: calc(100vh - 80px);
	}
}
</style>